const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const pad = (n) => String(n).padStart(2, "0");

const parse = (v) => {
  const m = v && v.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
  return m ? { y: m[1], mo: m[2], d: m[3], h: m[4], mi: m[5], s: m[6] || "00" } : null;
};

const selCls =
  "rounded-lg border border-white/10 bg-panel px-2 py-2.5 text-sm text-neutral-200 focus:border-gold focus:outline-none";

// Explicit Day / Month / Year / Hour / Minute (+ optional Second) editors.
// Value format matches datetime-local ("YYYY-MM-DDTHH:MM[:SS]") or "" when empty (allowEmpty).
export const DateTimeFields = ({ value, onChange, testid, allowEmpty = false, withSeconds = false }) => {
  const parts = parse(value);
  const now = new Date();
  const base = parts || {
    y: String(now.getFullYear()),
    mo: pad(now.getMonth() + 1),
    d: pad(now.getDate()),
    h: pad(now.getHours()),
    mi: pad(now.getMinutes()),
    s: pad(now.getSeconds()),
  };
  const dim = new Date(+base.y, +base.mo, 0).getDate();
  const years = [];
  for (let y = 2015; y <= now.getFullYear() + 1; y++) years.push(String(y));

  const emit = (key, v) => {
    if (!v) return;
    const next = { ...base, [key]: v };
    if (key === "y" || key === "mo") {
      const maxD = new Date(+next.y, +next.mo, 0).getDate();
      if (+next.d > maxD) next.d = pad(maxD);
    }
    onChange(`${next.y}-${next.mo}-${next.d}T${next.h}:${next.mi}${withSeconds ? `:${next.s}` : ""}`);
  };

  const field = (key, options, labels, tid) => (
    <select
      value={parts ? base[key] : ""}
      onChange={(e) => emit(key, e.target.value)}
      className={selCls}
      data-testid={`${testid}-${tid}`}
    >
      {!parts && <option value="">—</option>}
      {options.map((o, i) => (
        <option key={o} value={o}>{labels ? labels[i] : o}</option>
      ))}
    </select>
  );

  const range = (a, b) => Array.from({ length: b - a + 1 }, (_, i) => pad(a + i));

  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-3 gap-2">
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-600">Day</span>
          {field("d", range(1, dim), null, "day")}
        </label>
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-600">Month</span>
          {field("mo", range(1, 12), MONTHS, "month")}
        </label>
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-600">Year</span>
          {field("y", years, null, "year")}
        </label>
      </div>
      <div className={`mt-2 grid gap-2 ${withSeconds ? "grid-cols-3" : "grid-cols-2"}`}>
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-600">Hour (24h)</span>
          {field("h", range(0, 23), null, "hour")}
        </label>
        <label className="flex flex-col gap-1">
          <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-600">Minute</span>
          {field("mi", range(0, 59), null, "minute")}
        </label>
        {withSeconds && (
          <label className="flex flex-col gap-1">
            <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-600">Second</span>
            {field("s", range(0, 59), null, "second")}
          </label>
        )}
      </div>
      {allowEmpty && parts && (
        <button
          type="button"
          onClick={() => onChange("")}
          data-testid={`${testid}-clear`}
          className="mt-2 text-[10px] font-medium text-neutral-500 underline underline-offset-2 transition-colors hover:text-rose-300"
        >
          Clear — use current time instead
        </button>
      )}
    </div>
  );
};
